<!-- Dialog: Switch Profile -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title }} </p-header>

  <div class="bfx-switch-profile-body">
    <div class="bfx-switch-profile-body-row">
      <div>{{data.dialogData.dropdownLabel}}</div>
      <div>
        <bfx-autoComplete
          #platformProfileSelection
          appendTo="body"
          size="sm"
          [(ngModel)]="platformProfile"
          [suggestions]="platformProfileSuggestions"
          (completeMethod)="searchPlatformProfile($event)"
          [dropdown]="true"
          [autoHighlight]="false"
          delay="4"
          field="label"
          dataKey="value"
          [maxlength]="50"
          [skipSorting]="true"
          (onSelect)="onSelectPlatformProfile($event)"
          (onFocus)="$event.target.select()"
        ></bfx-autoComplete>
      </div>
    </div>
    <div class="switch-divider"></div>
    <div class="switch-profile-warning bfx-callout-warning-sm bfx-callout-wrap">
      <div>{{data.dialogData.warningMessage1}}</div>
      <div>{{data.dialogData.warningMessage2}}</div>
    </div>
  </div>

  <p-footer>
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="switchProfileCancel()"
      label="Cancel"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="switchProfileYes()"
      label="Switch Profile"
      [disabled]="!data.dialogData.switchEnabled || platformProfileSuggestions.length === 0"
    ></button>
  </p-footer>
</p-dialog>
